import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'

createRoot(document.getElementById('appRoot')!).render(
  <StrictMode>
    <meta name="robots" content="noindex"></meta>
    <meta name="apple-mobile-web-app-capable" content="yes"></meta>
    <link rel="apple-touch-icon" href="https://www.trailfinders.com/apple-touch-icon.png" />
    <App />
  </StrictMode>,
)
